const Serve = () => import("@/pages/serve/index")
const ClassifyManagement = () => import("@/pages/serve/classify/list")
const ClassifyEditor = () => import("@/pages/serve/classify/editor")
const ServeManagement = () => import("@/pages/serve/serve-management/list")
const ServeEditor = () => import("@/pages/serve/serve-management/editor")
const Message = () => import("@/pages/serve/message")

export default[
    {
        path: '/serve-management',
        component: Serve,
        children: [
            {
                path: 'classify-management',
                component: ClassifyManagement,
                meta: [
                    {
                        name: '分类管理',
                        url: ''
                    }
                ]
            },
            {
                path: 'classify-management/add',
                component: ClassifyEditor,
                meta: [
                    {
                        name: '分类管理',
                        url: '/serve-management/classify-management'
                    },
                    {
                        name: '新增分类',
                        url: 'add'
                    }
                ]
            },
            {
                path: 'classify-management/set/:id',
                component: ClassifyEditor,
                meta: [
                    {
                        name: '分类管理',
                        url: '/serve-management/classify-management'
                    },
                    {
                        name: '编辑分类',
                        url: 'set'
                    }
                ]
            },
            {
                path: 'serve-management-management',
                component: ServeManagement,
                meta: [
                    {
                        name: '服务管理',
                        url: ''
                    },
                ]
            },
            {
                path: 'serve-management-management/add',
                component: ServeEditor,
                meta: [
                    {
                        name: '服务管理',
                        url: '/serve-management/serve-management-management'
                    },
                    {
                        name: '新增服务企业',
                        url: 'add'
                    },
                ]
            },
            {
                path: 'serve-management-management/set/:id',
                component: ServeEditor,
                meta: [
                    {
                        name: '服务管理',
                        url: '/serve-management/serve-management-management'
                    },
                    {
                        name: '编辑服务企业',
                        url: 'set'
                    },
                ]
            },
            {
                path: 'message-management',
                component: Message,
                meta: [
                    {
                        name: '意向留言列表',
                        url: ''
                    },
                ]
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/serve.js